export default __webpack_public_path__ + "static/media/socket.50c8053c.png";